import { MenuStructure } from "services/KnowfullyAdminClient";

export class MenuStructureModel extends MenuStructure {
  subRows?: MenuStructure[];
}

export function mapToMenuStructureModels(menuStructures?: MenuStructure[]) {
  return (
    menuStructures
      ?.filter((ms) => !ms.parentMenuStructureId)
      .map(
        (ms) =>
          ({
            ...ms,
            subRows: menuStructures.filter(
              (m) => m.parentMenuStructureId === ms.id
            ),
          } as MenuStructureModel)
      ) ?? []
  );
}

export const menuStructureTableCommonProps = {
  enableFilters: false,
  enableDensityToggle: false,
  enableColumnActions: false,
  enableFullScreenToggle: false,
  enableHiding: false,
  enableExpandAll: false,
  enableExpanding: true,
  enablePagination: false,
};
